import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";

const name = "devices";

import store from "@/store";
// Imported from an import-free leaf: the initializers below run during bootstrap, where a throw
// blanks the whole app. See the note in PersistedState.ts.
import { readPersistedArray } from "@/store/PersistedState";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { DeviceCategoryTemplate } from "@/data/models/DeviceCategoryTemplate";
import { DeviceTemplate } from "@/data/models/DeviceTemplate";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class DevicesVuexModule extends VuexModule {
  deviceOverviewCache = new Map<string, DeviceOverview>();

  selectedCategories: Array<DeviceCategoryTemplate> =
    readPersistedArray<DeviceCategoryTemplate>("selectedCategories") ?? [];

  selectedTemplates: Array<DeviceTemplate> =
    readPersistedArray<DeviceTemplate>("selectedTemplates") ?? [];


  @Mutation
  cacheDeviceOverview(deviceOverview: DeviceOverview) {
    this.deviceOverviewCache.set(deviceOverview.inventoryNumber, deviceOverview);
  }

  @Mutation
  setSelectedCategories(update: Array<DeviceCategoryTemplate>) {
    this.selectedCategories = update;
    localStorage.setItem("selectedCategories", JSON.stringify(update));
  }

  @Mutation
  setSelectedTemplates(update: Array<DeviceTemplate>) {
    this.selectedTemplates = update;
    localStorage.setItem("selectedTemplates", JSON.stringify(update));
  }

  @Mutation
  clear() {
    this.deviceOverviewCache.clear();
    this.selectedCategories = [];
    this.selectedTemplates = [];
  }
}

export const DevicesModule = getModule(DevicesVuexModule);
